import hero from './hero.json';
import meta from './meta.json';

export const checkoutSuccess = {
  meta,
  hero,
};
